import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from "nuqs";
import { COMPARISON_MODES, COMPARISON_OPTIONS, DAY_SUB_RANGES } from "./types";
import type { ComparisonUrlState } from "./types";

export const comparisonParsers = {
  cmp_mode: parseAsStringLiteral(COMPARISON_MODES),
  cmp_option: parseAsStringLiteral(COMPARISON_OPTIONS),
  cmp_count: parseAsInteger,
  cmp_sub: parseAsStringLiteral(DAY_SUB_RANGES),
  cmp_from: parseAsString,
  cmp_to: parseAsString,
  cmp_dim: parseAsString,
};

export const useComparisonQueryStates = () => {
  return useQueryStates(comparisonParsers, { history: "push" });
};

export const isComparisonActive = (state: ComparisonUrlState): boolean => {
  return state.cmp_mode !== null && state.cmp_option !== null;
};
